import { Observable } from 'rxjs';
import { BlocEvent } from '../base-bloc';


export type TreeDropDownCallBack<T> = (page:number , limit : number , search?:string) => Observable<any>;

export abstract class TreeDropdownEvent extends BlocEvent {}

// Initiate
export class TreeDropdownInitiateEvent extends TreeDropdownEvent {}

// Load
export class TreeDropdownLoadEvent<T> extends TreeDropdownEvent {
  constructor(public caller: TreeDropDownCallBack<T> , public page : number , public limit : number , public search?: string) {
    super();
  }
}

export class TreeDropdownSearchEvent<T> extends TreeDropdownEvent {
  constructor(public caller: TreeDropDownCallBack<T> , public page : number , public limit : number , public search: string) {
    super();
  }
}
